import { Redirect } from 'react-router';

import { useCompany } from 'modules/app/hooks/useCompany';
import { AccountPayableSuppliers } from 'modules/bookkeep/accounts-payable/AccountPayableSuppliers';
import { useIntegrationStatusQuery } from 'modules/bookkeep/hooks';
import { isIntegrationStatusWithIntegration } from 'modules/bookkeep/integration/status';
import { unwrapQuery } from 'src/core/api/unwrapQuery';
import { HeaderWithNavigation } from 'src/core/common/components/HeaderWithNavigation/HeaderWithNavigation';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';

export const SettingsAccountsPayable = () => {
  const { t } = useTranslation('global');
  const integrationStatusQueryState = useIntegrationStatusQuery();
  const company = useCompany();

  const links = [
    {
      key: 'current',
      text: t('bookkeep.accountsPayable.list.table.current'),
      path: routeFor(routes.COMPANY_ACCOUNTS_PAYABLE.path, {
        company: company.id,
        list: 'current',
      }),
    },
    {
      key: 'archived',
      text: t('bookkeep.accountsPayable.list.table.archived'),
      path: routeFor(routes.COMPANY_ACCOUNTS_PAYABLE.path, {
        company: company.id,
        list: 'archived',
      }),
    },
  ].filter((link) => link !== null);

  const status = unwrapQuery(integrationStatusQueryState);

  if (status ? isIntegrationStatusWithIntegration(status) : true) {
    return (
      <div className="page__container">
        <HeaderWithNavigation links={links}>
          {t('settings.links.accountsPayable')}
        </HeaderWithNavigation>
        <div className="grow bg-background-primary-default px-40 py-24">
          <AccountPayableSuppliers integrationStatus={status} />
        </div>
      </div>
    );
  }

  return <Redirect to={routes.COMPANY_ACCOUNTING_INTEGRATION.path} />;
};
